var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"community"},[_c('service-introduction',{staticClass:"service-introduction",attrs:{"introductionData":_vm.introductionData,"showTab":_vm.showTab}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img-class"},[_c('div',{staticClass:"middle-class"}),_c('div',{staticClass:"bottom-class"})])
}]

export { render, staticRenderFns }